var e = function () {
  var e, n;

  if ("undefined" != typeof window) {
    var t = {
      setRippleListener: !1,
      registeredRippleElements: new WeakMap()
    };
    return null !== (n = (e = window).__LEAFYGREEN_UTILS__) && void 0 !== n || (e.__LEAFYGREEN_UTILS__ = {
      modules: {}
    }), window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"] = t, window.__LEAFYGREEN_UTILS__.modules["@leafygreen-ui/ripple"];
  }
}();

function n(n) {
  null != e && e.registeredRippleElements.has(n.target) && function (n) {
    var t = n.target,
        i = null == e ? void 0 : e.registeredRippleElements.get(t);
    if (!t || !i) return;
    var o = i.backgroundColor,
        r = t.getBoundingClientRect(),
        a = document.createElement("span");
    a.className = "lg-ui-ripple", a.style.height = a.style.width = Math.max(r.width, r.height) + "px", t.appendChild(a);
    var s = n.pageY - r.top - a.offsetHeight / 2 - document.body.scrollTop,
        l = n.pageX - r.left - a.offsetWidth / 2 - document.body.scrollLeft;
    a.style.top = s + "px", a.style.left = l + "px", a.style.background = o, setTimeout(function () {
      a.remove();
    }, 750);
  }(n);
}

function t(t, o) {
  if (e) {
    if (e.registeredRippleElements.set(t, o), !e.setRippleListener) {
      document.addEventListener("click", n, {
        passive: !0
      });
      var r = document.createElement("style");
      r.innerHTML = i, document.head.append(r), e.setRippleListener = !0;
    }

    return function () {
      e.registeredRippleElements.delete(t);
    };
  }
}

var i = "\n  @-webkit-keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ".concat(300, "ms;\n      opacity: 0;\n    }\n  }\n\n  @-moz-keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ").concat(300, "ms;\n      opacity: 0;\n    }\n  }\n\n  @keyframes lg-ui-ripple {\n    from {\n      opacity:1;\n    }\n    to {\n      transform: scale(2);\n      transition: opacity ").concat(300, "ms;\n      opacity: 0;\n    }\n  }\n\n  .lg-ui-ripple {\n    position: absolute;\n    border-radius: 100%;\n    transform: scale(0.2);\n    opacity: 0;\n    pointer-events: none;\n    // Ensures that text is shown above ripple effect\n    z-index: -1;\n    -webkit-animation: lg-ui-ripple .75s ease-out;\n    -moz-animation: lg-ui-ripple .75s ease-out;\n    animation: lg-ui-ripple .75s ease-out;\n  }\n\n  @media (prefers-reduced-motion: reduce) {\n    .lg-ui-ripple {\n      animation: none;\n      transform: none;\n    }\n  }\n");
export { t as registerRipple };